export default __webpack_public_path__ + "static/media/instagram.3045b2af.svg";